import React, { Component } from 'react';

export const InfoAds = ( props ) => {
    const { ads_position } = props;
	const isUS = localStorage.getItem( 'site_of_origin' ).toLowerCase() !== 'us';
	return (
		<div className={`info-ads ${ ads_position === 'top' ? "top" : "bottom" }`}>
			<div className="subtitle pull-left">Sponsored Advert</div>
			<a href={ `https://${ isUS ? 'us.' : '' }intouchnetworks.com/advertisers.php` } target="_blank" className="intouchads pull-right">
				<span className="label">In Touch Ads</span>
				<span className="icon"><img src="/images/INT-advertisment-services.png" alt=""/></span>
			</a>
		</div>
	)
}


// WEBPACK FOOTER //
// src/client/components/common/adverts/infoAds.js